// extracted by mini-css-extract-plugin
export default {"container":"prompt-scroll_container__A5qIR","content":"prompt-scroll_content__6Z59x","icon":"prompt-scroll_icon__2CQUx","bounce":"prompt-scroll_bounce__taiIh"};